import React from 'react';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
// reactstrap components
import { Breadcrumb, BreadcrumbItem, Button, Container, Row, Col } from 'reactstrap';
// const coverImage = require('assets/img/olympic/header.png').default;
const coverImage = require('assets/img/olympic/banner_testbank.jpg').default;
class TimelineHeader extends React.Component {
  render() {
    return (
      <>
        <div className='header header-dark  pb-6 content__title content__title--calendar' style={{ backgroundColor: '#EEEEEE' }}>
          <Container fluid>
            <div className='header-body'>
              <Col>
                <Row>
                  <img alt='Tháp học tập' className='img-fluid' src={coverImage} style={{ borderRadius: 40 }} />
                </Row>
                {/* <Row className='align-items-center py-4'>
                  <Col lg='6' xs='7'>
                    <Breadcrumb className='d-none d-md-inline-block ml-lg-4' listClassName='breadcrumb-links breadcrumb-dark'>
                      <BreadcrumbItem>
                        <a href='#pablo' onClick={(e) => e.preventDefault()}>
                          <i className='fas fa-home' style={{ color: '#525F7F' }} />
                        </a>
                      </BreadcrumbItem>
                      <BreadcrumbItem>
                        <a href='#pablo' onClick={(e) => e.preventDefault()} style={{ color: '#525F7F' }}>
                          {this.props.parentName}
                        </a>
                      </BreadcrumbItem>
                      <BreadcrumbItem aria-current='page' className='active' style={{ color: '#525F7F' }}>
                        {this.props.name}
                      </BreadcrumbItem>
                    </Breadcrumb>
                  </Col>
                </Row> */}
              </Col>
            </div>
          </Container>
        </div>
      </>
    );
  }
}

TimelineHeader.propTypes = {
  name: PropTypes.string,
  parentName: PropTypes.string,
};

export default TimelineHeader;
